import React, {ReactElement} from 'react';

interface Props {
    size?: number;
    className?: string;
}

export default function Discord({size = 24, className}: Props): ReactElement {
    return (
        <svg
            viewBox="0 0 17 16"
            className={className}
            width={size}
            height={size}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.447 8a.66.66 0 00.2.471.688.688 0 00.963 0 .66.66 0 000-.943.688.688 0 00-.963 0 .66.66 0 00-.2.472zM9.532 8a.66.66 0 00.2.471.688.688 0 00.963 0 .66.66 0 000-.943.688.688 0 00-.963 0 .66.66 0 00-.2.472z"
                stroke="#fff"
                strokeWidth={0.667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.787 11.334c0 .666-.923 2-1.248 2-.973 0-1.837-1.112-2.269-2-.432-1.112-.324-3.889.972-7.667.945-.677 1.895-.893 2.885-1l.664 1.282a8.281 8.281 0 012.76 0l.661-1.282c1.022.107 2.072.323 3.064 1 1.362 3.778 1.476 6.555 1.021 7.667-.454.888-1.361 2-2.383 2-.34 0-1.361-1.334-1.361-2M4.766 11c2.383.667 4.425.667 6.808 0"
                stroke="#fff"
                strokeWidth={0.667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
